import React, { useEffect, useState } from 'react';
import Navbar from '../Components/Navbar';
import Footer from '../Components/Footer';
import './Home.css';
import PALMLEAF from '../images/PALMLEAF.webp'; // Adjust path as necessary 
import { Link } from 'react-router-dom'; // Import Link from react-router-dom
import SOLARSYSTEM from '../images/SOLARSYSTEM.jpg'; // Adjust path as necessary
import ASTROLOGICALIMAGES from '../images/ASTROLOGICALIMAGES.jpg'; // Adjust path as necessary
import NADIASTROLOGYIMAGES from '../images/NADIASTROLOGYIMAGES.jpg'; // Adjust path as necessary
import TYPESOFNADI from '../images/TYPESOFNADI.jpg'; // Adjust path as necessary
import NADIASTROLOGYREGAI from '../images/NADIASTROLOGYREGAI.webp'; // Adjust path as necessary
import SPRITULAGUIDENCE from '../images/SPRITULAGUIDENCE.png'; // Adjust path as necessary
import WHATISNADIASTRO from '../images/WHATISNADIASTRO.webp'; // Adjust path as necessary
import ORGINOFNADIASTRO from '../images/ORGINOFNADIASTRO.avif'; // Adjust path as necessary
import SPECIALOFNADIASTROLOGY from '../images/SPECIALOFNADIASTROLOGY.jpg'; // Adjust path as necessary
import WHYCHOOSENADIASTROLOGY from '../images/WHYCHOOSENADIASTROLOGY.jpg'; // Adjust path as necessary
import FUTUREOFNADI from '../images/FUTUREOFNADI.avif'; // Adjust path as necessary
import COSMICNADIIMAGES from '../images/COSMICNADIIMAGES.webp'; // Adjust path as necessary
import NADIGURUJI from '../images/NADIGURUJI.webp'; // Adjust path as necessary
import LORDSHIVEHEROS from '../images/LORDSHIVEHEROS.webp'; // Adjust path as necessary
import OMSOUND from '../images/OMSOUND.mp3'; // Adjust path as necessary
import LORDSHIVA2 from '../images/LORDSHIVA2.png'; // Adjust path as necessary
import HEROMERGED from '../images/HEROMERGED.png'; // Adjust path as necessary
// import SUGUMARSWAMY1 from '../images/DSUGUMARSWAMY1.jpg';
import VAITHEESWARANTEMPLE from '../images/VAITHEESWARANTEMPLE.png';
  import LORDSHIVAGIF from '../images/LORDSHIVAGIF.mp4';
import WHATHERO from '../images/WHATHERO.jpg';
import Topbar from './Topbar';
import BOOKING from './Booking';
import Remedies from './Remedies';
import Chaptercard from './Chaptercard';
import SUGUMARSWAMY from '../images/DSUGUMARSWAMY.jpg';
import Remedycard from './Remedycard';






import GALLERY1 from '../images/1.jpg';
import GALLERY2 from '../images/2.jpeg';
import GALLERY3 from '../images/3.jpg';
import GALLERY4 from '../images/4.jpg';
import GALLERY5 from '../images/5.jpeg';
import GALLERY6 from '../images/6.jpg';
import GALLERY7 from '../images/7.jpg';
import GALLERY8 from '../images/8.jpg';
import GALLERY9 from '../images/9.jpg';
import GALLERY10 from '../images/10.jpg';
import GALLERY11 from '../images/11.jpg';
import GALLERY12 from '../images/12.jpg';
import GALLERY13 from '../images/13.jpg';
import GALLERY14 from '../images/14.jpg';
import GALLERY15 from '../images/15.jpg';
import GALLERY16 from '../images/16.jpg';
import GALLERY17 from '../images/17.jpg';
import GALLERY18 from '../images/18.jpeg';
import GALLERY19 from '../images/19.mp4';
import GALLERY20 from '../images/20.jpeg';


import Top from './Top';

import Languages from './Languages';






export default function Home() {
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the page
  }, []);


  
  // Play the OM sound when the page loads
  // window.addEventListener('load', function () {
  //   const omSound = document.getElementById('om-sound');
  //   omSound.play();
  // });


  // const images = [LORDSHIVA2];
  // const titles = ["ONLINE SHIVA NADI ASTROLOGY"];

  // const [currentImageIndex, setCurrentImageIndex] = useState(0);
  // const [currentTitleIndex, setCurrentTitleIndex] = useState(0);

  // useEffect(() => {
  //   const imageInterval = setInterval(() => {
  //     setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
  //   }, 5000); 

  //   const titleInterval = setInterval(() => {
  //     setCurrentTitleIndex((prevIndex) => (prevIndex + 1) % titles.length);
  //   }, 3000);

  //   return () => {
  //     clearInterval(imageInterval);  
  //     clearInterval(titleInterval);  
  //   };
  // }, [images.length, titles.length]);
  
  


  // useEffect(() => {
    
  //   const images = document.querySelectorAll('.col-6 img');

  //   const handleScroll = () => {
  //     images.forEach((image) => {
  //       const imagePosition = image.getBoundingClientRect().top;
  //       const screenPosition = window.innerHeight;

        
  //     });
  //   };

  //   window.addEventListener('scroll', handleScroll);

    
  //   handleScroll();

  //   return () => {
  //     window.removeEventListener('scroll', handleScroll);
  //   };
  // }, []);





  // const [currentIndex, setCurrentIndex] = useState(0);

  // const services = [
  //   { image: WHATHERO, title: "Online Shiva Nadi Astrology", description: "Best Nadi Astrology In Tamilnadu."},
  //   { image: PALMLEAF, title: "Online Shiva Nadi Astrology", description: "Best Nadi Astrology In Tamilnadu."},
  //   { image: LORDSHIVEHEROS, title: "Online Shiva Nadi Astrology", description: "Best Nadi Astrology In India"},
  //   { image: SOLARSYSTEM, title: "Shiva Nadi Astrology", description: "Best Nadi Astrology In tamilnadu"},
  //   { image: NADIASTROLOGYREGAI, title: "Best Nadi Astrology Service", description: "Best Nadi Astrology" },
    
  // ];

  // const nextService = () => {
  //   setCurrentIndex((prevIndex) => (prevIndex + 1) % services.length);
  // };

  // const prevService = () => {
  //   setCurrentIndex((prevIndex) => (prevIndex - 1 + services.length) % services.length);
  // };












  return (



    
    <div>
      <Top/>
      <div><Navbar /></div>



  


      <div>




<section id="hero">
  <video autoPlay loop muted playsInline className="hero-video">
    <source src={LORDSHIVAGIF} type="video/mp4" />
  </video>

  <div className="hero-overlay"></div>

  <div className="hero-content">
    <h1>ONLINE SHIVA NADI ASTROLOGY</h1>
    <p>Predict Your Life With Shiva Nadi Astrology</p>
    <a href="tel:+917402167580" className="hero-btn">Get Appointment?</a>
  </div>

  {/* Moving Images Section */}
  <div className="moving-images">
    <div className="image-track">
      <img src={GALLERY1} alt="Shiva 1" title="Shiva 1" />
      <img src={GALLERY2} alt="Shiva 2" title="Shiva 2" />
      <img src={GALLERY3} alt="Shiva 3" title="Shiva 3" />
      <img src={GALLERY4} alt="Shiva 4" title="Shiva 4" />
      <img src={GALLERY9} alt="Shiva 5" title="Shiva 5" />
      <img src={GALLERY10} alt="Shiva 6" title="Shiva 6" />
      <img src={GALLERY11} alt="Shiva 7" title="Shiva 7" />
      <img src={GALLERY12} alt="Shiva 8" title="Shiva 8" />
    </div>
  </div>
</section>

<Languages/>
{/* <section
  id="languages1"
  style={{
    width: "100%",
    background: "linear-gradient(135deg, #007bff 0%, #004aad 100%)",
    padding: "60px 20px",
    textAlign: "center",
    color: "#fff",
    fontFamily: "'Poppins', sans-serif",
  }}
>
 
  <h2
    style={{
      fontSize: "28px",
      fontWeight: 700,
      marginBottom: "30px",
      letterSpacing: "1px",
      color: "#fff",
    }}
  >
    Available Languages
  </h2>


  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexWrap: "wrap",
      gap: "20px",
    }}
  >
    {[
      { name: "English", text: "English" },
      { name: "Hindi", text: "हिन्दी" },
      { name: "Telugu", text: "తెలుగు" },
      { name: "Malayalam", text: "മലയാളം" },
      { name: "Kannada", text: "ಕನ್ನಡ" },
    ].map((lang, index) => (
      <div
        key={index}
        style={{
          background: "rgba(255,255,255,0.15)",
          border: "1px solid rgba(255,255,255,0.2)",
          borderRadius: "30px",
          padding: "12px 25px",
          minWidth: "120px",
          textAlign: "center",
          fontWeight: 600,
          fontSize: "18px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
          transition: "transform 0.3s ease, background 0.3s ease",
        }}
        onMouseOver={(e) => {
          e.currentTarget.style.transform = "scale(1.08)";
          e.currentTarget.style.background = "rgba(255,255,255,0.25)";
        }}
        onMouseOut={(e) => {
          e.currentTarget.style.transform = "scale(1)";
          e.currentTarget.style.background = "rgba(255,255,255,0.15)";
        }}
      >
        {lang.text}
      </div>
    ))}
  </div>

  
  <style>
    {`
      @media (max-width: 768px) {
        #languages1 {
          padding: 45px 15px !important;
        }
        #languages1 h2 {
          font-size: 22px !important;
          margin-bottom: 25px !important;
        }
        #languages1 div {
          font-size: 15px !important;
          padding: 8px 18px !important;
          min-width: 100px !important;
        }
      }

      @media (max-width: 480px) {
        #languages1 {
          padding: 35px 10px !important;
        }
        #languages1 h2 {
          font-size: 20px !important;
          margin-bottom: 20px !important;
        }
        #languages1 div {
          width: 100% !important;
          max-width: 220px !important;
          margin: 6px auto !important;
          font-size: 14px !important;
          padding: 7px 15px !important;
          border-radius: 25px !important;
        }
      }
    `}
  </style>
</section> */}



      {/* <section className="hero">
     
      <video autoPlay loop muted playsInline className="hero-video">
  <source src={LORDSHIVAGIF} type="video/mp4" />
  Your browser does not support the video tag.
</video>


  
      <div className="hero-overlay">
        <h1>ONLINE SHIVA NADI ASTROLOGY</h1>
        <p className="hero-slogan">Get Solutions For Your Future</p>
        <a href="tel:+917402167580">
          <button className="hero-button1">Tamil, Telugu, Malayalam, English, Hindi</button> <br />
          <button className="hero-button">Get Appointment</button>
        </a>
      </div>

     
      <div className="image-slider">
        <div className="image-track">
          <img src={GALLERY1} alt="Moving Img" />
          <img src={GALLERY2} alt="Moving Img" />
          <img src={GALLERY3} alt="Moving Img" />
          <img src={GALLERY4} alt="Moving Img" />
          <img src={GALLERY5} alt="Moving Img" />
       
          <img src={GALLERY1} alt="Moving Img" />
          <img src={GALLERY2} alt="Moving Img" />
          <img src={GALLERY3} alt="Moving Img" />
          <img src={GALLERY4} alt="Moving Img" />
          <img src={GALLERY5} alt="Moving Img" />
        </div>
      </div>
    </section> */}






      {/* <section
        id="hero"
        style={{
          backgroundImage: `url(${images[currentImageIndex]})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="hero-content">
          <h1 className={`hero-title animated-title-${currentTitleIndex}`}>{titles[currentTitleIndex]}</h1>
          <p className="hero-slogan">Get Solutions For Your Future</p>
          <a href="tel:+918072585095">
            <button className="hero-button1">Tamil, Telugu, Malayalam, English, Hindi</button> <br/>
            <button className="hero-button">Get Appointment</button>
          </a>
        </div>
      </section> */}






       <section id="desc1">
  <div className="container">
    <div className="row">

      {/* ORIGIN OF NADI ASTROLOGY */}
      <div className="col-12 text-center mb-4">
        <h2>Origin of Nadi Astrology</h2>
      </div>

      <div className="col-12">
        <img
          src={VAITHEESWARANTEMPLE}
          alt="Vaitheeswaran Koil Temple"
          className="card-img-top img-fluid mb-4"
          style={{ borderRadius: "10px" }}
        />

        <p>
          <strong>Nadi Astrology</strong> is one of the oldest forms of predictive science, believed to have originated in <strong>Tamil Nadu, India</strong>. This ancient knowledge was revealed by enlightened sages, known as <strong>Rishis</strong>, through deep meditation and divine vision. Among these sages, <strong>Sage Agasthiya</strong> holds a prominent place.
        </p>

        <p>
          These Rishis, through their yogic insight, recorded the destinies of individuals on <strong>palm leaves</strong>, known as <strong>Nadi Leaves</strong>. The writings describe each person’s past, present, and future — including karmic patterns and remedies for life’s challenges.
        </p>

        <p>
          During the <strong>Chola dynasty</strong>, these sacred palm leaves were preserved in temples such as <strong>Vaitheeswaran Koil</strong>. Over centuries, they were carefully handed down to families who became custodians of this divine knowledge.
        </p>

        <p>
          The process of Nadi reading begins with the seeker’s <strong>thumb impression</strong>. Based on this, the astrologer identifies the matching set of palm leaves. Once found, the leaf reveals highly personal insights — guiding the individual towards spiritual understanding and karmic balance.
        </p>

        <p>
          Nadi Astrology remains a living spiritual tradition, combining <strong>ancient wisdom</strong> with <strong>personal guidance</strong> for those seeking clarity, purpose, and peace in life.
        </p>
      </div>

      {/* AGASTHIYA RISHI DETAILS */}
      <div className="col-12 text-center mt-5 mb-4">
        <h2>Agasthiya Rishi Details</h2>
      </div>

      <div className="col-lg-6 col-md-6 col-sm-12 col-12 mb-3">
        <img
          src={ORGINOFNADIASTRO}
          alt="Agasthiya Rishi"
          className="card-img-top img-fluid"
          style={{ borderRadius: "10px" }}
        />
      </div>

      <div className="col-lg-6 col-md-6 col-sm-12 col-12">
        <p>
          <strong>Agasthiya Rishi</strong> — also known as <strong>Agastya</strong> — is one of the most revered sages in Indian spiritual heritage. Recognized as one of the <strong>Sapta Rishis</strong> (seven great sages), he is a disciple of <strong>Lord Shiva</strong> and is celebrated as the <strong>Father of Tamil Literature</strong> and <strong>Siddha Medicine</strong>.
        </p>

        <p>
          According to ancient scriptures, Sage Agasthiya was born from a divine pot created by <strong>Lord Brahma</strong>, earning him the name <strong>“Kumbha Muni.”</strong> His mission was to spread dharma and wisdom across South India.
        </p>

        <p>
          Agasthiya Rishi is deeply connected with <strong>Nadi Astrology</strong>. Through divine meditation, he foresaw the destinies of countless souls and recorded them on palm leaves in the ancient Tamil script. These writings — known as <strong>Agasthiya Nadi</strong> — serve as a spiritual roadmap for understanding life and karma.
        </p>

        <p>
          The manuscripts reveal details about one’s family, health, career, spirituality, and karma, along with <strong>specific remedies</strong> to reduce difficulties and improve harmony.
        </p>

        <p>
          To this day, <strong>Agasthiya Nadi</strong> continues to guide devotees worldwide, offering insight, direction, and spiritual healing. His teachings emphasize self-awareness, compassion, and divine connection — principles that remain timeless and universal.
        </p>
      </div>

    </div>
  </div>
</section>






        

<section id="About" style={{ backgroundColor: "#ffffff" }}>

          <div className="container">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                <div className="about-heading">
                  <h2>About</h2>
                </div>
                <p>
                  Welcome to Shiva Nadi Astrology! With over six years of dedicated service, we are your trusted partner in discovering profound insights about your life and destiny. At Shiva Nadi Astrology, we specialize in offering personalized astrological guidance rooted in ancient wisdom, ensuring that every individual receives meaningful and accurate predictions.
                </p>
                <p>
                  We take pride in our commitment to authenticity and professionalism. Transparency and trust form the foundation of our service, keeping you informed and supported throughout your spiritual journey. Our team of experienced astrologers is devoted to unveiling the secrets of your past, present, and future to help you make enlightened decisions.
                </p>
                <p>
                  Your spiritual well-being is our driving force. Whether you seek clarity on life's challenges or guidance for your path ahead, Shiva Nadi Astrology is here to illuminate your way with wisdom and care. Thank you for choosing Shiva Nadi Astrology—where ancient knowledge meets your aspirations!
                </p>
              </div>
            </div>
          </div>
        </section>









<section id="profile-section">
  <div className="content-wrapper">
    
    {/* Guruji Photo */}
    <div className="profile-photo">
      <div className="photo-wrapper">
        <img
          src={SUGUMARSWAMY}
          alt="Chief Nadi Astrologer - Mr. D. Sugumar Swamy"
          className="card-img-top"
        />
        <h5>Mr. D. Sugumar Swamy</h5>
        <p>Chief Nadi Astrologer</p>
      </div>
    </div>

    {/* Content */}
    <div className="profile-content">
      <h2>Our Chief Nadi Astro Reader</h2>
      <p>
        <strong>Mr. D. Sugumar Swamy</strong> is a highly respected Nadi
        astrologer based in Hyderabad, India, with decades of experience in
        <strong> Nadi Jyotish, Palm Leaf Reading, and Astrology.</strong> His
        center is among the oldest Nadi Astrology establishments in India,
        tracing back four generations of dedicated service.
      </p>
      <p>
        With a commitment to preserving this ancient science, he continues the
        legacy of his forefathers who served devotees worldwide. Thousands have
        benefited from his precise readings, which provide clarity, guidance,
        and remedies for life’s challenges.
      </p>
      <ul>
        <li>Expert in traditional palm-leaf readings.</li>
        <li>Renowned for accurate predictions and practical remedies.</li>
        <li>Guided thousands towards peace and spiritual balance.</li>
      </ul>
      <p>
        His compassionate approach and ability to connect <strong>ancient
        wisdom</strong> with <strong>modern life</strong> make him one of the
        most trusted astrologers in the field. Consultations are now available
        both in-person and online.
      </p>
    </div>
  </div>
</section>


       

<section id="About" style={{ backgroundColor: "#ffffff" }}>

          <div className="container">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                <div className="about-heading">
                  <h2>Get Appointment</h2>
                </div>
               <h4><strong>Procedure Of prediction</strong></h4>
               <p>astrology is a unique predictive system that offers insights into an individual’s past, present, and future by referring to ancient palm-leaf manuscripts. The process involves several distinct steps, combining spiritual practices with detailed record-keeping.</p>
              <ul><li id="listcolor"><strong>Thumb Impression Collection</strong></li> </ul>
              <p>The process begins with collecting the individual’s thumb impression. For men, the right thumb is used, and for women, the left thumb. Each thumb impression is categorized into specific patterns, which correspond to bundles of palm leaves.</p>




              <ul><li id="listcolor"><strong>Identification of the Palm Leaf</strong></li> </ul>
              <p>The astrologer uses the thumb impression to identify the relevant set of palm-leaf manuscripts. These bundles are further narrowed down by asking the individual a series of questions. The responses help pinpoint the exact leaf containing their life details.</p>

              <ul><li id="listcolor"><strong>Reading the Nadi Leaf</strong></li> </ul>
              <p>Once the correct leaf is identified, the astrologer reads its contents aloud. The text is written in ancient Tamil, requiring expertise to interpret. It includes details such as the person’s name, family, career, and significant life events.</p>



              <ul><li id="listcolor"><strong>Predictions and Remedies</strong></li> </ul>
              <p>In modern times, many astrologers provide written or recorded versions of the predictions for future reference. Clients are encouraged to follow the suggested remedies to align their life with the guidance provided in the leaf.</p>


              <ul><li id="listcolor"><strong> Recording and Follow-Up</strong></li> </ul>
              <p>The Nadi leaf not only reveals life events but also provides predictions about the future. These predictions include guidance on overcoming challenges and achieving success. Specific remedies, such as rituals, prayers, or acts of charity, are often recommended to mitigate negative karma.</p>



              <ul><li id="listcolor"><strong>Significance of the Process</strong></li> </ul>
              <p>The entire procedure reflects the spiritual depth of Nadi astrology. It emphasizes the influence of past karma and offers actionable steps to create a positive future. The process is a blend of ancient wisdom and personalized guidance.</p>

              </div>
            </div>
          </div>
        </section>






<div><BOOKING/></div>

<div><Chaptercard/></div>
{/* <div><Remedies/></div> */}
<div><Remedycard/></div>











<section id="gallery-section">
  <div class="container">
    <div class="row">
      <div class="col-lg-3 col-md-4 col-sm-6 col-12 gallery-item">
        <img src={GALLERY1} alt="Gallery Image 1" class="gallery-img" />
      </div>
      <div class="col-lg-3 col-md-4 col-sm-6 col-12 gallery-item">
        <img src={GALLERY2} alt="Gallery Image 2" class="gallery-img" />
      </div>
      <div class="col-lg-3 col-md-4 col-sm-6 col-12 gallery-item">
        <img src={GALLERY3} alt="Gallery Image 3" class="gallery-img" />
      </div>
      <div class="col-lg-3 col-md-4 col-sm-6 col-12 gallery-item">
        <img src={GALLERY4} alt="Gallery Image 4" class="gallery-img" />
      </div>
      {/* <div class="col-lg-3 col-md-4 col-sm-6 col-12 gallery-item">
        <img src={GALLERY5} alt="Gallery Image 5" class="gallery-img" />
      </div> */}
      <div class="col-lg-3 col-md-4 col-sm-6 col-12 gallery-item">
        <img src={GALLERY6} alt="Gallery Image 6" class="gallery-img" />
      </div>
      <div class="col-lg-3 col-md-4 col-sm-6 col-12 gallery-item">
        <img src={GALLERY7} alt="Gallery Image 7" class="gallery-img" />
      </div>
      <div class="col-lg-3 col-md-4 col-sm-6 col-12 gallery-item">
        <img src={GALLERY8} alt="Gallery Image 8" class="gallery-img" />
      </div>
      <div class="col-lg-3 col-md-4 col-sm-6 col-12 gallery-item">
        <img src={GALLERY9} alt="Gallery Image 9" class="gallery-img" />
      </div>
      <div class="col-lg-3 col-md-4 col-sm-6 col-12 gallery-item">
        <img src={GALLERY10} alt="Gallery Image 10" class="gallery-img" />
      </div>
      <div class="col-lg-3 col-md-4 col-sm-6 col-12 gallery-item">
        <img src={GALLERY11} alt="Gallery Image 11" class="gallery-img" />
      </div>
      <div class="col-lg-3 col-md-4 col-sm-6 col-12 gallery-item">
        <img src={GALLERY12} alt="Gallery Image 12" class="gallery-img" />
      </div>
      <div class="col-lg-3 col-md-4 col-sm-6 col-12 gallery-item">
        <img src={GALLERY13} alt="Gallery Image 12" class="gallery-img" />
      </div>
      {/* <div class="col-lg-3 col-md-4 col-sm-6 col-12 gallery-item">
        <img src={GALLERY14} alt="Gallery Image 12" class="gallery-img" />
      </div> */}
      <div class="col-lg-3 col-md-4 col-sm-6 col-12 gallery-item">
        <img src={GALLERY15} alt="Gallery Image 12" class="gallery-img" />
      </div>
      <div class="col-lg-3 col-md-4 col-sm-6 col-12 gallery-item">
        <img src={GALLERY16} alt="Gallery Image 12" class="gallery-img" />
      </div>
      {/* <div class="col-lg-3 col-md-4 col-sm-6 col-12 gallery-item">
        <img src={GALLERY17} alt="Gallery Image 12" class="gallery-img" />
      </div> */}
      {/* <div class="col-lg-3 col-md-4 col-sm-6 col-12 gallery-item">
        <img src={GALLERY18} alt="Gallery Image 12" class="gallery-img" />
      </div> */}
      <div class="col-lg-3 col-md-4 col-sm-6 col-12 gallery-item">
        <video src={GALLERY19} alt="Gallery Image 12" class="gallery-img" />
      </div>
      {/* <div class="col-lg-3 col-md-4 col-sm-6 col-12 gallery-item">
        <img src={GALLERY20} alt="Gallery Image 12" class="gallery-img" />
      </div> */}
    </div>
  </div>
</section>











        <section id="new-card-desc">
      <div className="container">
        <div className="row">
          {/* Card 1 */}
          <div className="col-lg-3 col-md-4 col-sm-6 col-12">
            <div className="floating-card">
              <img src={ASTROLOGICALIMAGES} alt="Types of Nadi Astrology" className="card-image" />
              <h3 className="card-title">Types of Nadi Astrology</h3>
              <p className="card-text">Discover various types like Agasthiya, Brighu, and Sukha Nadi.</p>
            </div>
          </div>
          {/* Card 2 */}
          <div className="col-lg-3 col-md-4 col-sm-6 col-12">
            <div className="floating-card">
              <img src={TYPESOFNADI} alt="Origin of Nadi Astrology" className="card-image" />
              <h3 className="card-title">Origin of Nadi Astrology</h3>
              <p className="card-text">Learn about its ancient roots in Tamil Nadu.</p>
            </div>
          </div>
          {/* Card 3 */}
          <div className="col-lg-3 col-md-4 col-sm-6 col-12">
            <div className="floating-card">
              <img src={NADIASTROLOGYREGAI} alt="Palm Leaf Readings" className="card-image" />
              <h3 className="card-title">Palm Leaf Readings</h3>
              <p className="card-text">Explore the sacred palm leaf manuscripts.</p>
            </div>
          </div>
          {/* Card 4 */}
          <div className="col-lg-3 col-md-4 col-sm-6 col-12">
            <div className="floating-card">
              <img src={SPRITULAGUIDENCE} alt="Spiritual Guidance" className="card-image" />
              <h3 className="card-title">Spiritual Guidance</h3>
              <p className="card-text">Understand its spiritual significance in life decisions.</p>
            </div>
          </div>
        </div>
      </div>
    </section>





    <section id="desc1">
<div className='container'>
  <div className='row'>

  <div className='col-lg-6 col-md-6 col-sm-12 col-12'>

  <img src={NADIASTROLOGYIMAGES} alt="Palm Leaf Readings" className="card-img-top" />

  </div>
  <div className='col-lg-6 col-md-6 col-sm-12 col-12'>

  <h2>Power of Nadi Astrology?</h2>

  <p>Nadi Astrology is an ancient and divine system of prediction that unveils your life's journey through sacred palm leaf manuscripts. These leaves, written thousands of years ago by enlightened sages, hold detailed insights into your past, present, and future. By decoding these ancient texts, Nadi Astrology provides personalized guidance, spiritual remedies, and clarity about your life’s purpose. It connects you to your karmic patterns and helps overcome obstacles with tailored solutions. Experience the wisdom of the sages and unlock the secrets of your destiny. With its unparalleled accuracy, Nadi Astrology is a powerful tool for self-discovery and transformation. Embark on this spiritual journey to achieve balance, harmony, and fulfillment in your life.</p>

  </div>




  </div>

</div>

  



</section>

{/* <section
  id="UGC"
  style={{ backgroundImage: `url(${COSMICNADIIMAGES})` }}
>
  <div className="container">
    <h2 className="gallery-title">Explore the World of Nadi Astrology</h2>
    <p className="gallery-description">
      Nadi Astrology is an ancient art originating from Tamil Nadu, known for its spiritual insights and life-changing predictions. Learn more about its origins, uniqueness, and why it continues to captivate seekers worldwide.
    </p>
    <div className="gallery-row">
      <div className="gallery-item">
        <img src={WHATISNADIASTRO} alt="Solar System" />
        <h3 className="item-title">What is Nadi Astrology?</h3>
        <p className="item-text">
          Nadi Astrology is an ancient Indian science that uses thumb impressions to reveal personalized life insights from palm-leaf manuscripts.
        </p>
        <a href="/Whatastro"><button>Learn</button></a>
      </div>
      <div className="gallery-item">
        <img src={ORGINOFNADIASTRO} alt="Astrological Image" />
        <h3 className="item-title">Origin of Nadi Astrology</h3>
        <p className="item-text">
          Nadi Astrology originated in Tamil Nadu, India, with ancient sages inscribing divine life insights on palm leaves thousands of years ago.
        </p>
        <button>Learn</button>
      </div>
      <div className="gallery-item">
        <img src={SPECIALOFNADIASTROLOGY} alt="Palm Leaf" />
        <h3 className="item-title">Special of Nadi Astrology</h3>
        <p className="item-text">
          Nadi Astrology uniquely uses ancient palm leaf manuscripts to unveil detailed insights about an individual's life.
        </p>
        <button id="btns">Learn</button>
      </div>
      <div className="gallery-item">
        <img src={WHYCHOOSENADIASTROLOGY} alt="Spiritual Guidance" />
        <h3 className="item-title">Why Choose Nadi Astrology?</h3>
        <p className="item-text">
          Choose Nadi Astrology for personalized spiritual insights and life guidance to unlock your full potential.
        </p>
        <button id="btns">Learn</button>
      </div>
      <div className="gallery-item">
        <img src={FUTUREOFNADI} alt="Find Future" />
        <h3 className="item-title">Find Your Future with Nadi Astrology</h3>
        <p className="item-text">
          Discover your future and navigate life's challenges with profound wisdom and clarity through Nadi Astrology.
        </p>
        <button>Learn</button>
      </div>
    </div>
  </div>
</section> */}





<section id="faq-section">
  <h2>Frequently Asked Questions (FAQ)</h2>
  <div class="faq-table">
    <div class="faq-row faq-header">
      <div class="faq-cell">No.</div>
      <div class="faq-cell">Question</div>
      <div class="faq-cell">Answer</div>
    </div>
    <div class="faq-row">
      <div class="faq-cell">1</div>
      <div class="faq-cell">What is Nadi Astrology?</div>
      <div class="faq-cell">
        Nadi Astrology is an ancient predictive science that uses palm leaf manuscripts to reveal an individual's destiny, written by sages thousands of years ago.
      </div>
    </div>
    <div class="faq-row">
      <div class="faq-cell">2</div>
      <div class="faq-cell">How does Shiva Nadi Astrology differ from Nadi Astrology?</div>
      <div class="faq-cell">
        Shiva Nadi Astrology is a specialized branch focusing on Lord Shiva’s divine blessings and guidance for spiritual growth and life decisions.
      </div>
    </div>
    <div class="faq-row">
      <div class="faq-cell">3</div>
      <div class="faq-cell">How can I find my palm leaf for Nadi Astrology?</div>
      <div class="faq-cell">
        Your thumb impression is used to match with the ancient manuscripts and locate your unique palm leaf.
      </div>
    </div>
    <div class="faq-row">
      <div class="faq-cell">4</div>
      <div class="faq-cell">What type of predictions does Nadi Astrology offer?</div>
      <div class="faq-cell">
        It provides detailed insights into your past, present, and future, covering health, career, relationships, and spiritual growth.
      </div>
    </div>
    <div class="faq-row">
      <div class="faq-cell">5</div>
      <div class="faq-cell">Is Nadi Astrology accurate?</div>
      <div class="faq-cell">
        Yes, it is known for its precise and personalized predictions based on your karmic records.
      </div>
    </div>
  </div>
</section>



        <div><Footer /></div>
      </div>
    </div>
  );
}
